module.exports = __webpack_public_path__ + "static/media/avatar-27.39fcbe51.svg";